import { theme } from '@frontend/theme';
import { Icon } from './icon-component';
import { IconName } from './icon-constant';

/**
 * This component is to enforce best practices when using a icon.
 * Icons should not be modified directly - it will adapt to the parent container.
 */
export const ContainedIcon = ({
  as = 'span',
  iconName,
  className,
  background,
  color,
  size,
}: {
  as?: React.ElementType;
  iconName: IconName;
  className?: string;
  background?: string;
  color?: string;
  size?: number;
}) => {
  const Component = as;
  return (
    <Component
      className={className}
      css={{
        background: background ?? 'transparent',
        display: 'inline-block',
        color: color ?? theme.colors.black,
        width: size ?? 16,
        height: size ?? 16,

        svg: {
          width: '100%',
          height: '100%',
        },
      }}
    >
      <Icon
        name={iconName}
        css={{
          svg: {
            width: '100%',
            height: '100%',
          },
        }}
      />
    </Component>
  );
};
